import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Spinner,
  Nav,
  NavItem,
  TabContent,
  Button,
  Badge,
} from 'reactstrap';
import TabPane from 'reactstrap/lib/TabPane';
import TooltipItem from '../../shared/components/TooltipItem';
import DataTable from '../../shared/components/DataTable';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import {
  get,
  getSubjectStudents,
  downloadSubjectStudents,
  downloadSubjectStudentsScore,
  changeUtilizaPorcentajePesoMateria,
  stampSubject,
  publishSubject,
} from '../../redux/actions/materiaPeriodoActions';

import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../helpers/notification';
import {
  actualizarNotas,
} from '../../redux/actions/studentSubjectsActions';
import PlaneamientoForm from './PlaneamientoForm/index';
import RegistroContenido from './PlaneamientoForm/components/RegistroContenido/Index';
import Homework from '../MateriasPeriodo/Homework/index';
import StudentAssistance from '../Assistance';

import EditarNotasDialog from './EditarNotasDialog';
import Confirm from '../../shared/components/Confirm';
import {
  EstadoMateriaPeriodo,
} from '../../constants/enums';

class ProfessorDataContainer extends PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingAlumnosMateria: true,
      items: [],
      tareas: [],
      filters: {
        page: 1,
        pageSize: 20,
        numeroDocumento: '',
        nombreAlumno: '',
        apellidoAlumno: '',
      },
      activeTab: '1',
      currentInscription: {},
      materiaPeriodo: null,
    };

    this.inputStyle = {
      fontSize: '18px',
      color: 'greenyellow',
      textAlign: 'center',
      fontWeight: 'bold',
      backgroundColor: 'transparent',
    };

    this.columnsStudents = [
      {
        key: 'numeroDocumento',
        name: 'Nº documento',
        width: '130px',
        search: true,
      },
      {
        key: 'apellidoAlumno',
        name: 'Apellido',
        search: true,
      },
      {
        key: 'nombreAlumno',
        name: 'Nombre',
        search: true,
      },
      { key: 'phoneNumber', name: 'Teléfono' },
      { key: 'email', name: 'E-Mail' },
    ];

    this.columns = ({
      calculatePPFromTasks,
      tareas,
      canEditTask,
      canEditAttendances,
      showAssistPercentageInScores,
    }) => {
      const cols = [
        {
          key: 'numeroDocumento',
          name: 'Nº documento',
          width: '120px',
          search: true,
        },
        {
          key: 'apellidoAlumno',
          name: 'Apellido',
          visible: false,
          search: true,
        },
        {
          key: 'nombreAlumno',
          name: 'Nombre',
          search: true,
          format: row => `${row.apellidoAlumno}, ${row.nombreAlumno}`.trim(),
        },
      ];

      const scores = tareas.map(t => ({
        key: `tareas${t.id}`,
        name: t.tipoTarea.value !== 2
          ? `Tarea #${t.id} ${t.utilizaPorcentajePesoMateria ? `(${t.porcentajePesoMateria})%` : ''}`
          : (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              {
                <button key={`tareas-btn-${t.id}`} type="button" className="action-button" tabIndex="-1">
                  <TooltipItem
                    style={{ whiteSpace: 'normal' }}
                    value={
                      `Tarea #${t.id} ${t.utilizaPorcentajePesoMateria ? `(${t.porcentajePesoMateria})%` : ''}`
                    }
                    label={
                      t.tipoTarea.label
                    }
                    key={`tareas-tooltip-${t.id}`}
                    color="warning"
                  />
                </button>
              }
            </span>
          ),
        width: '126px',
        className: 'text-center',
        format: ({ calificaciones = [] }) => (
          <>
            {calificaciones.filter(c => c.tareaId === t.id).map(c => c.puntaje)[0] || 0}
            {'/'}
            {t.puntajeTotal}
          </>
        ),
      }));

      return [
        ...cols,
        ...scores,
        ...[
          {
            key: 'porcentajePP',
            name: '% PP',
            editable: !calculatePPFromTasks && canEditTask,
            type: 'number',
            min: 0,
            max: 100,
            width: '100px',
            className: 'text-center',
            inputStyle: () => this.inputStyle,
            format: ({ porcentajePP }) => (
              <Badge
                color="primary"
                pill
                style={{
                  fontSize: '15px',
                  textAlign: 'center',
                  fontWeight: 'normal',
                }}
              >
                {porcentajePP}
              </Badge>
            ),
          },
          {
            visible: showAssistPercentageInScores,
            key: 'porcentajeAsistencia',
            name: '% Asistencia',
            editable: canEditAttendances && !canEditTask,
            type: 'number',
            min: '0',
            max: '100',
            width: '110px',
            className: 'text-center',
            inputStyle: () => this.inputStyle,
            format: ({ porcentajeAsistencia }) => (
              <Badge
                color="primary"
                pill
                style={{
                  fontSize: '15px',
                  textAlign: 'center',
                  fontWeight: 'normal',
                }}
              >
                {Math.round(porcentajeAsistencia)}
              </Badge>
            ),
          },
          {
            key: 'actions',
            name: 'Accion',
            width: '100px',
            visible: false,
          },
        ],
      ];
    };

    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar notas" />,
        callback: (inscription) => {
          this.editarNotas(inscription);
        },
      },
    ];
    this.downloadAlumnosMateria.bind(this);
    this.downloadAlumnosMateriaNotas.bind(this);
    this.editarNotas.bind(this);
  }

  componentDidMount() {
    this.refreshTables();
  }

  refreshTables = () => {
    this.updateMateriaPeriodo();
    this.updateAlumnosMateria();
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({ activeTab: tab });
      if (tab === '5') {
        this.updateAlumnosMateria();
        return;
      }

      if (tab === '3') {
        this.updateAlumnosMateria();
      }
    }
  };

  handleChangeUtilizaPorcentajePesoMateria = (values) => {
    const { id } = this.props;

    const { utilizaPorcentajePesoMateria } = values;

    changeUtilizaPorcentajePesoMateria({
      payload: {
        id: Number(id),
        allow: utilizaPorcentajePesoMateria,
      },
      onSuccess: () => {
        this.refreshTables();
        createSuccessMessage('Materia actualizada exitosamente.');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Error al intentar actualizar la materia');
        }
        this.refreshTables();
      },
    });
  };

  updateMateriaPeriodo = () => {
    const { id } = this.props;
    this.setState({ loading: true });
    get({
      id,
      onSuccess: (materiaPeriodo) => {
        this.setState({
          materiaPeriodo, loading: false,
        });
      },
      onError: () => {
        this.setState({
          items: [],
          tareas: [],
          loading: false,
        });
        createErrorMessage('Error al intentar cargar los datos de la materia');
      },
    });
  }

  editarNotas = (inscription) => {
    this.setState({ currentInscription: inscription });
    EditarNotasDialog({
      inscripcionMateria: inscription,
      onValueChanges: (key, value) => {
        const { currentInscription } = this.state;
        this.setState({ currentInscription: { ...currentInscription, [key]: +value } });
      },
      onConfirm: () => {
        const { currentInscription } = this.state;

        const { id, porcentajeAsistencia, porcentajePP } = currentInscription;

        actualizarNotas({ id, porcentajeAsistencia, porcentajePP }, {
          onSuccess: () => {
            createSuccessMessage('Asistencia y/o notas guardada(s) exitosamente.');
            const { pageSize, filters } = this.state;
            this.updateAlumnosMateria(1, pageSize, filters);
          },
          onError: (error) => {
            if (error.message) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Ocurrió un error al intentar guardar la asistencia y/o nota.');
            }
          },
        });
      },
    });
  };

  autoguardarNota = (row, key, value) => {
    const { items } = this.state;
    const trow = items.find(r => r.id === row.id);

    if (!trow) return;
    trow[key] = +value;

    const { id, porcentajeAsistencia, porcentajePP } = { ...row, [key]: +value };

    actualizarNotas({ id, porcentajeAsistencia, porcentajePP }, {
      onSuccess: () => {
        createSuccessMessage('Asistencia y/o notas guardada(s) exitosamente.');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la asistencia y/o nota.');
        }
      },
    });
  };

  goBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  updateAlumnosMateria = (page, pageSize, filters) => {
    const { id } = this.props;

    this.setState({
      loadingAlumnosMateria: true,
      filters: filters || {},
    });

    getSubjectStudents({
      filters,
      id,
      onSuccess: ({ materias: items, tareas }) => {
        this.setState({
          loadingAlumnosMateria: false,
          items,
          tareas,
          totalItemsCount: items.length,
        });
      },
      onError: () => {
        this.setState({
          items: [],
          tareas: [],
          loadingAlumnosMateria: false,
        });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  downloadAlumnosMateria = () => {
    const { id } = this.props;
    this.setState({ loadingAlumnosMateria: true });
    downloadSubjectStudents({
      id,
      onSuccess: () => {
        createSuccessMessage('Lista descargada exitosamente');
        this.setState({ loadingAlumnosMateria: false });
      },
      onError: () => {
        this.setState({ loadingAlumnosMateria: false });
        createErrorMessage('Error al intentar descargar la lista de alumnos');
      },
    });
  }

  downloadAlumnosMateriaNotas = () => {
    const { id } = this.props;
    this.setState({ loadingAlumnosMateria: true });
    downloadSubjectStudentsScore({
      id,
      onSuccess: () => {
        this.setState({ loadingAlumnosMateria: false });
        createSuccessMessage('Lista descargada exitosamente');
      },
      onError: () => {
        this.setState({ loadingAlumnosMateria: false });
        createErrorMessage('Error al intentar descargar la lista de calificaciones alumnos');
      },
    });
  }

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateAlumnosMateria(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize, filters } = this.state;
    const { autoHideSearch } = filters;
    this.updateAlumnosMateria(1, pageSize, { autoHideSearch });
  };

  planeamientoForm = (activeTab) => {
    if (activeTab !== '3') {
      return null;
    }

    const { materiaPeriodo } = this.state;
    return (
      <PlaneamientoForm
        planningId={materiaPeriodo.id}
        materiaPeriodo={materiaPeriodo}
      />
    );
  };

  registroContenido = (activeTab) => {
    if (activeTab !== '4') {
      return null;
    }

    const { materiaPeriodo } = this.state;
    return (
      <RegistroContenido
        subjectPeriodId={materiaPeriodo.id}
        profesoresMateria={materiaPeriodo.profesoresMateria}
        esFinClases={materiaPeriodo.periodo.item.esFinClases}
      />
    );
  };

  getStutus = (estado = {}) => {
    let color = 'secondary';

    if (estado.value === EstadoMateriaPeriodo.Publicado.value) {
      color = 'info';
    }

    if (estado.value === EstadoMateriaPeriodo.Sellado.value) {
      color = 'success';
    }

    return (
      <Badge
        style={{ fontSize: '0.81rem', paddingTop: '0.7rem' }}
        color={color}
        pill
      >
        {estado.label}
      </Badge>
    );
  };

  changeStatus = ({ materiaPeriodo = {} }) => {
    if (materiaPeriodo.estado === undefined) {
      return null;
    }

    let button = <></>;
    if (materiaPeriodo.estado.value === EstadoMateriaPeriodo.Preliminar.value) {
      button = (
        <button
          type="button"
          className="btn btn-primary btn-sm"
          style={{ marginBottom: '0' }}
          onClick={() => this.handlePublishSubject(materiaPeriodo)}
        >
          <i className="fa fa-unlock" /> Publicar
        </button>
      );
    }

    if (materiaPeriodo.estado.value === EstadoMateriaPeriodo.Publicado.value) {
      button = (
        <button
          type="button"
          className="btn btn-primary btn-sm"
          style={{ marginBottom: '0' }}
          onClick={() => this.handleStampSubject(materiaPeriodo)}
        >
          <i className="fa fa-lock" /> Sellar
        </button>
      );
    }

    return (
      <Row>
        <Col md={12} style={{ marginBottom: '10px', marginTop: '10px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            <h4 style={{ textAlign: 'end' }}>Estado:</h4>
            {this.getStutus(materiaPeriodo.estado)}
            {button}
          </div>
        </Col>
      </Row>
    );
  };

  handlePublishSubject = (materiaPeriodo) => {
    const {
      materiaMalla,
    } = materiaPeriodo;

    Confirm({
      title: 'Publicar materia',
      question: `¿Estás seguro que deseas publicar la materia ${materiaMalla.label}?
Una vez publicado ya no será editable.`,
      yesLabel: 'Si, Publicar materia',
      noLabel: 'No, Volver',
      color: 'success',
      onConfirm: () => {
        publishSubject({
          id: materiaPeriodo.id,
          subject: materiaPeriodo,
          onSuccess: () => {
            createSuccessMessage('Materia publicada exitosamente');
            this.refreshTables();
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La materia no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar publicar la materia');
            }
          },
        });
      },
    });
  };

  handleStampSubject = (materiaPeriodo) => {
    const {
      materiaMalla,
    } = materiaPeriodo;

    Confirm({
      title: 'Sellar materia',
      question: `¿Estás seguro que deseas sellar la materia ${materiaMalla.label}?
Una vez sellado ya no será editable.`,
      yesLabel: 'Si, Sellar materia',
      noLabel: 'No, Volver',
      color: 'success',
      onConfirm: () => {
        stampSubject({
          id: materiaPeriodo.id,
          subject: materiaPeriodo,
          onSuccess: () => {
            createSuccessMessage('Materia sellada exitosamente');
            this.refreshTables();
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('La materia no existe');
            } else if (error && error.status === 400) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar sellar la materia');
            }
          },
        });
      },
    });
  };

  showTabStudentAssistance = ({ id, editarAsistencias, tabId }) => {
    if (editarAsistencias) {
      return null;
    }

    return (
      <TabPane tabId={tabId}>
        <Row>
          {tabId === '6' ? <StudentAssistance subjectPeriodId={id} /> : null}
        </Row>
      </TabPane>
    );
  }

  homeworkForm = ({ materiaPeriodo, tabId }) => {
    if (tabId !== '2') {
      return null;
    }

    return (
      <Homework
        materiaPeriodoId={materiaPeriodo.id}
        finCalificarTareas={materiaPeriodo.finCalificarTareas}
        canEdit={materiaPeriodo.canEditTask}
        utilizaPorcentajePesoMateria={materiaPeriodo.utilizaPorcentajePesoMateria}
        handleSubmit={this.handleChangeUtilizaPorcentajePesoMateria}
      />
    );
  }

  render() {
    const {
      materiaPeriodo,
      loading,
      loadingAlumnosMateria,
      items,
      tareas,
      totalItemsCount,
      filters,
      activeTab,
    } = this.state;

    if (loading || !materiaPeriodo) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h2 className="page-title text-center">
              Plan semestral de clases
            </h2>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}>
              <h3 className="page-title">
                <span>{materiaPeriodo.materia.label}</span>
              </h3>
              <em style={{ fontSize: '16px', color: 'slategray' }}>{materiaPeriodo.seccion}</em>
            </div>
            <em style={{ fontSize: '12px', color: 'slategray' }}>Periodo {materiaPeriodo.periodo.label}</em>
            <div className="form" style={{ marginTop: '0.5rem' }}>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Carrera:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.carrera}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Semestre:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.semestre}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Año:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.anho}</h5>
                </div>
              </Col>
              <Col sm={6} md={3} lx={12}>
                <div className="card__title" style={{ display: 'flex', columnGap: '0.5rem' }}>
                  <h5 className="bold-text">Horas Semanales:{' '}</h5>
                  <h5 className="bold-text">{materiaPeriodo.horasSemanal}</h5>
                </div>
              </Col>
            </div>

          </Col>
        </Row>
        {this.changeStatus({ materiaPeriodo })}
        <Row>
          <Col md={12}>
            <Container>
              <Nav tabs style={{ gap: '0.3rem' }}>
                <NavItem>
                  {activeTab === '1'
                    ? (<Button active color="secondary" className="mb-0">Alumnos</Button>)
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        onClick={() => this.toggle('1')}
                      >
                        Alumnos
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem>
                  {activeTab === '2'
                    ? (
                      <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                        Tareas
                      </Button>
                    )
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => this.toggle('2')}
                      >
                        Tareas
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem>
                  {activeTab === '3'
                    ? (
                      <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                        Planeamiento
                      </Button>
                    )
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => this.toggle('3')}
                      >
                        Planeamiento
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem>
                  {activeTab === '4'
                    ? (
                      <Button active color="secondary" className="mb-0" style={{ marginBottom: '1rem' }}>
                        Registro de Contenidos
                      </Button>
                    )
                    : (
                      <Button
                        outline
                        color="secondary"
                        className="mb-0"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => this.toggle('4')}
                      >
                        Registro de Contenidos
                      </Button>
                    )
                  }
                </NavItem>
                <NavItem>
                  {activeTab === '5'
                    ? (<Button active color="secondary" className="mb-0">Calificaciones</Button>)
                    : (
                      <Button outline color="secondary" className="mb-0" onClick={() => this.toggle('5')}>
                        Calificaciones
                      </Button>
                    )
                  }
                </NavItem>
                {!materiaPeriodo.editarAsistencias ? (
                  <NavItem>
                    {activeTab === '6'
                      ? (<Button active color="secondary" className="mb-0">Asistencias</Button>)
                      : (
                        <Button outline color="secondary" className="mb-0" onClick={() => this.toggle('6')}>
                          Asistencias
                        </Button>
                      )
                    }
                  </NavItem>
                ) : null}
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane className="tabs--bordered-top" tabId="1">
                  <Row>
                    {
                      loadingAlumnosMateria ? (
                        <Col md={12} className="text-center">
                          <h3 className="page-subhead subhead">
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                          </h3>
                        </Col>
                      )
                        : (
                          <>
                            <Col md={12}>
                              <div className="text-left">
                                <button
                                  style={{ height: '3rem' }}
                                  className="btn btn-link btn-lg mb-0 pt-1 pb-1"
                                  type="button"
                                  onClick={this.downloadAlumnosMateria}
                                >
                                  <span className="fa fa-cloud-download">&nbsp;</span>
                                  Descargar lista
                                </button>
                              </div>
                            </Col>

                            <DataTable
                              title="Listado de todos los alumnos"
                              columns={this.columnsStudents}
                              items={items}
                              onChangePage={this.onChangePage}
                              totalItemsCount={totalItemsCount}
                              onSubmit={this.onDataTableSubmit}
                              onClearFilters={this.onDataTableClearFilters}
                              getGridActions={key => this.getGridActions(key)}
                              onAutoSave={this.autoguardarNota}
                              itemsToShow={items.length}
                              page={1}
                              pageSize={totalItemsCount}
                              autoHideSearch={filters.autoHideSearch}
                              initialValues={filters}
                              enableReinitialize
                            />
                          </>
                        )
                    }
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    {this.homeworkForm({ materiaPeriodo, tabId: activeTab })}
                  </Row>
                </TabPane>
                <TabPane tabId="3">
                  <Row>
                    {this.planeamientoForm(activeTab)}
                  </Row>
                </TabPane>
                <TabPane tabId="4">
                  <Row>
                    {this.registroContenido(activeTab)}
                  </Row>
                </TabPane>
                <TabPane tabId="5">
                  <Row>
                    {
                      loadingAlumnosMateria ? (
                        <Col md={12} className="text-center">
                          <h3 className="page-subhead subhead">
                            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                          </h3>
                        </Col>
                      )
                        : (
                          <>
                            <Col md={12}>
                              <div className="text-left">
                                <button
                                  style={{ height: '3rem' }}
                                  className="btn btn-link btn mb-0 pt-1 pb-1"
                                  type="button"
                                  onClick={this.downloadAlumnosMateriaNotas}
                                >
                                  <span className="fa fa-cloud-download">&nbsp;</span>
                                  Descargar lista
                                </button>
                              </div>
                            </Col>
                            <DataTable
                              title="Listado de todas las notas"
                              columns={this.columns({
                                canEditTask: materiaPeriodo.canEditTask,
                                canEditAttendances: materiaPeriodo.editarAsistencias,
                                calculatePPFromTasks: materiaPeriodo.calculatePPFromTasks,
                                showAssistPercentageInScores: materiaPeriodo.showAssistPercentageInScores,
                                tareas,
                              })}
                              items={items}
                              onChangePage={this.onChangePage}
                              totalItemsCount={totalItemsCount}
                              onSubmit={this.onDataTableSubmit}
                              onClearFilters={this.onDataTableClearFilters}
                              getGridActions={key => this.getGridActions(key)}
                              onAutoSave={this.autoguardarNota}
                              itemsToShow={items.length}
                              page={1}
                              pageSize={totalItemsCount}
                              autoHideSearch={filters.autoHideSearch}
                              initialValues={filters}
                              enableReinitialize
                            />
                          </>
                        )
                    }
                  </Row>
                </TabPane>
                {this.showTabStudentAssistance({ ...materiaPeriodo, tabId: activeTab })}

              </TabContent>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className="card__actions">
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={this.goBack.bind(this)}
              >Volver
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(ProfessorDataContainer);
